import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Plus, Calendar, Pencil, Megaphone, UploadCloud } from 'lucide-react'

const QuickActionsFab: React.FC = () => {
  const [open, setOpen] = useState(false)

  return (
    <div className="fixed bottom-24 right-5 z-50">
      {open && (
        <div className="mb-3 space-y-2">
          <Link to="/submit-event" className="block glass-card px-4 py-3 rounded-xl text-sm text-white/90 hover:text-white hover:bg-white/10">➜ Submit Event</Link>
          <Link to="/marketplace/new" className="block glass-card px-4 py-3 rounded-xl text-sm text-white/90 hover:text-white hover:bg-white/10">➜ New Listing</Link>
          <Link to="/reviews" className="block glass-card px-4 py-3 rounded-xl text-sm text-white/90 hover:text-white hover:bg-white/10">➜ Reviews</Link>
        </div>
      )}
      <button
        onClick={() => setOpen((v) => !v)}
        className={`btn-accent rounded-full w-14 h-14 flex items-center justify-center shadow-2xl`}
        aria-label="Quick Actions"
      >
        <Plus size={24} />
      </button>
    </div>
  )
}

export default QuickActionsFab


